//
// Copyright (c) 2023 Emplifi, Inc.
//

import { Plugin } from "ckeditor5";
import PreviewCommand from "./previewCommand";

export default class PreviewEditing extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  public static get pluginName() {
    return "PreviewEditing";
  }

  public init() {
    this.editor.commands.add("preview", new PreviewCommand(this.editor));
  }
}
